import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MyContext } from '../../context';
import DataTable from '../../components/tables/DataTable';
import Pagination from '../../components/Pagination';
import StatusBadge from '../../components/StatusBadge';
import { listFulfillments } from '../../utils/queries';

const PAGE_SIZE = 20;

// This page only ever shows shipped jobs -- pre-shipment tracking now lives
// on the Orders tab as the raw ERP job status column. Nothing writes a
// non-SHIPPED erp_fulfillments row today, but the status filter is passed
// explicitly (rather than omitted) as a defensive guard against that
// changing in the future.
export default function FulfillmentsList() {
	const { activeStoreId } = useContext(MyContext);
	const [fulfillments, setFulfillments] = useState([]);
	const [total, setTotal] = useState(0);
	const [page, setPage] = useState(0);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		listFulfillments({
			limit: PAGE_SIZE,
			offset: page * PAGE_SIZE,
			storeId: activeStoreId || undefined,
			status: 'SHIPPED',
		}).then((result) => {
			if (result?.success) {
				setFulfillments(result.data.fulfillments);
				setTotal(result.data.pagination.total);
			}
			setLoading(false);
		});
	}, [page, activeStoreId]);

	const columns = [
		{
			key: 'order_number',
			header: 'Order #',
			render: (value, row) => (
				<Link to={`/fulfillments/${row.erp_fulfillment_id}`} className='text-black font-medium hover:underline'>
					{value}
				</Link>
			),
		},
		{
			key: 'status',
			header: 'Status',
			render: (value) => <StatusBadge status='shipped' text={value} />,
		},
		{ key: 'tracking_number', header: 'Tracking #' },
		{
			key: 'shipped_at',
			header: 'Shipped At',
			render: (value) => (value ? new Date(value).toLocaleString() : ''),
		},
	];

	return (
		<div className='py-8 pr-8'>
			<h1 className='text-2xl font-light tracking-tight mb-6'>Shipped Orders</h1>

			<DataTable columns={columns} data={fulfillments} loading={loading} emptyHeading='No shipped orders found' />
			<Pagination pageCount={Math.ceil(total / PAGE_SIZE)} currentPage={page} onPageChange={setPage} />
		</div>
	);
}
